/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Form } from 'antd';
import { FocusEventHandler, useEffect } from 'react';

import { Input } from '@/primitives/Input';

export type EditableNodeNameFormProps = {
  name: string;
  onNameBlur: FocusEventHandler<HTMLInputElement>;
  setNodeName: (name: string) => void;
};

export function EditableNodeNameForm({ name, onNameBlur, setNodeName }: EditableNodeNameFormProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldValue('name', name);
    setNodeName(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, name]);

  return (
    <Form form={form} initialValues={{ name }} layout="vertical" style={{ width: '100%' }}>
      <Form.Item name="name">
        <Input
          allowClear
          count={{ max: 80 }}
          maxLength={80}
          dataTestId="node-name-input"
          onBlur={(event) => onNameBlur(event)}
          autoFocus
        />
      </Form.Item>
    </Form>
  );
}
